import { rootApi } from '../user/api';

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ['Dnta'],
});

export const dntaApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findAllDntas: builder.query({
      query: () => `dntaList`,
      providesTags: ['Dnta'],
    }),
    fetchDeliveryNotes: builder.query({
      query: () => `delvery_notes`,
      providesTags: ['Dnta'],
    }),
    findDntaById: builder.query({
      query: (id) => `dnta/${id}`,
      providesTags: (result, error, arg) => {
        return result ? [{ type: 'Dnta', id: result.id }] : ['Dnta'];
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useFindAllDntasQuery } = dntaApi;
